import ChatMascot from './ChatMascot';
import ReportGuidelinesCard from './ReportGuidelinesCard';

/**
 * Shown in the chat column whenever no conversation is selected.
 *
 * `motionPaused` is set while the welcome modal is open: the mascot behind the
 * scrim then holds still instead of drifting under a backdrop blur.
 */
export default function EmptyState({ motionPaused = false }) {
  return (
    <div className="animate-z2-rise mx-auto flex w-full max-w-[480px] flex-col items-center px-1 py-6 text-center">
      <ChatMascot className="h-[186px] w-[252px]" paused={motionPaused} />

      <h1 className="mt-4 text-[22px] leading-tight font-semibold tracking-tight text-ink">
        Welcome to Z2Market Chat
      </h1>
      <p className="mt-1.5 text-[13px] text-ink-2">Start chatting now!</p>

      <div className="mt-7 w-full">
        <ReportGuidelinesCard />
      </div>
    </div>
  );
}
